/**
 * @file Footer links columns toggle
 * 
 * @author Konrad Kaliszewski <kkaliszewski@squiz.pl>
 * @date April 2018
 */

var footerLinksColToggle = (function () {
    var colToggle = $('.footer-col__toggle');

    // Toggles quick search form 
    function toggleAriaExpanded(event) {
        var $toggledEl = $(event.target);
        if (!$toggledEl.hasClass('footer-col__toggle')) {
            $toggledEl = $toggledEl.parent();
        }
        var ariaExpanded = $toggledEl.attr('aria-expanded');
        var expanded;
        switch (ariaExpanded) {
            case "true": {
                expanded = true;
                $toggledEl.removeClass('footer-col__expanded');
                break;
            }
            case "false": {
                expanded = false;
                $toggledEl.addClass('footer-col__expanded');
                break;
            }
            default: {
                break;
            }
        }
        
        $toggledEl.attr('aria-expanded', !expanded);
    }

    // Binds all the events
    function bind() {
        colToggle.click(function(e) {
            toggleAriaExpanded(e);
        });
    }

    /**
     * Initialisation
     */
    return {
         init: function() {
            bind();
        }
    }
})();

(function() {
    footerLinksColToggle.init();
}(jQuery));